import { createReducer } from '@reduxjs/toolkit';
import { SET_EXPORTED } from '../constants/actionTypes';
import { ExportedState } from '../types';

export const exportedInitialState: ExportedState = {
  isExported: false,
  url: '',
};

export const exported = createReducer(
  exportedInitialState,
  {
    [SET_EXPORTED]: (
      state: ExportedState,
      resp: {
        payload: { isExported: boolean, url?: string };
      }
    ) => resp.payload,
  },
);
